module.exports = __webpack_public_path__ + "img/BGMain10.6a846e7b.jpg";